module.exports = __webpack_public_path__ + "769abba32ad5089bff2cd32fae375295.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/cubes.png
// module id = 3358
// module chunks = 0